import { t } from "i18next";
import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../context/AppContextProvider";
import { ActionTypes } from "../actions/actions";
import { DOCUMENT_CATEGORY_ENUM } from "../@types/document";
import i18n, { getDocumentaleLanguagePath } from "../i18n";
import { env } from "../lib/env";
import { ArrowUpRightIcon } from "./ArrowUpRightIcon";

const CATEGORIES_LIST = Object.values(DOCUMENT_CATEGORY_ENUM);

export function Categories() {
    const locale = i18n.language;
    const documentaleLang = getDocumentaleLanguagePath(locale);
    const showPrivateDocs = locale !== "en-US";

    const { state, dispatch } = useContext(AppContext);
    const { docs, product, selectedCategory } = state;
    const { seriale } = product;

    const categoriesList = docs.items.flatMap(doc => doc.categories);
    const categoriesSet = Array.from(new Set(categoriesList));
    const categoriesToDisplay = CATEGORIES_LIST.filter(category => categoriesSet.includes(category));

    const [mobile, setMobile] = useState(false)
    const divRef = useRef(null);
    const [isLarge, setIsLarge] = useState(false);

    function handleCategoryChange(category: string) {
        dispatch({
            type: ActionTypes.ChangeCategory,
            payload: category as DOCUMENT_CATEGORY_ENUM
        })
    }

    useEffect(() => {
        const mediaQuery: MediaQueryList = window.matchMedia("(max-width: 768px)");

        const handleScreenChange = (e: MediaQueryListEvent | MediaQueryList) => {
            if (e.matches) {
                setMobile(true);
            } else {
                setMobile(false);
            }
        };
        mediaQuery.addEventListener("change", handleScreenChange);
        handleScreenChange(mediaQuery);
        return () => {
            mediaQuery.removeEventListener("change", handleScreenChange);
        };
    }, []);

    useEffect(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            for (let entry of entries) {
                const width = entry.contentRect.width;
                if (width >= 1000) {
                    setIsLarge(true);
                } else {
                    setIsLarge(false);
                }
            }
        });

        if (divRef.current) {
            resizeObserver.observe(divRef.current);
        }

        return () => resizeObserver.disconnect();
    }, [categoriesSet]);

    useEffect(() => {
        const defaultCategory = selectedCategory ? selectedCategory : categoriesToDisplay[0];

        console.log("defaultCategory", defaultCategory)

        dispatch({
            type: ActionTypes.ChangeCategory,
            payload: defaultCategory
        })
    }, [selectedCategory, locale])

    return (
        <div
            ref={divRef}
            className={`flex flex-col md:flex-row items-center box-content w-full max-w-[1000px] ${isLarge ? "overflow-x-scroll" : ""} md:w-fit md:bg-gray-50 md:border md:border-gray-200 gap-3 md:gap-2 md:p-[6px] rounded-lg`}
        >
            {mobile ?
                <select
                    className="select-category w-full rounded-[8px] py-3 px-4 border bg-white border-gray-300 bg-no-repeat bg-[right_.7em_top_50%] bg-[url('/public/down-arrow.svg')]"
                    onChange={(e) => handleCategoryChange(e.currentTarget.value)}
                >
                    {categoriesToDisplay.map((category, index) => {
                        return (
                            <option
                                key={category}
                                value={category}
                                className="flex justify-between"
                                defaultChecked={selectedCategory === category}
                            >
                                {t(`docs.categories.${category}`)}
                            </option>
                        );
                    })
                    }
                </select>
                :
                categoriesToDisplay.map((category, index) => {
                    return (
                        <label key={category} className="category text-nowrap transition-all duration-300">
                            <input
                                key={category}
                                type="radio"
                                className="hidden"
                                value={category}
                                checked={selectedCategory === category}
                                onChange={(e) => handleCategoryChange(e.currentTarget.value)}
                            />
                            {t(`docs.categories.${category}`)}
                        </label>
                    );
                })
            }
            {showPrivateDocs && (
                <a
                    href={`${env.REACT_APP_DOCUMENTALE_URL}/${documentaleLang}/documentale/ricerca-per-seriale/lista?q=${seriale}`}
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center text-nowrap font-bold text-primary-700 bg-transparent md:bg-primary-50 md:border md:border-primary-200 gap-[8px] py-[10px] px-[16px] rounded-[6px] hover:bg-primary-200 transition-all duration-300"
                >
                    {t("docs.privateDocs")}
                    <ArrowUpRightIcon />
                </a>
            )}
        </div >
    )
}
